import { createAiChatHttpClient } from './httpClient';
import { chatbotConfigPath } from './paths';
import { getAiChatApiBase } from '../config';

/**
 * Persists chatbot module config. The API service must store and return
 * `introMessage` on GET `/chatbot/config/:moduleId` alongside other fields.
 *
 * @param {{
 *   projectId: string,
 *   moduleId: string,
 *   agentId: string,
 *   lakehouseName: string,
 *   lakehouseSQLEndpoint: string,
 *   customInstruction: string,
 *   introMessage: string,
 *   visibility: string,
 * }} body
 * @returns {Promise<unknown>}
 */
export async function postChatbotConfig(body) {
  if (!getAiChatApiBase()) {
    throw new Error('AI chat API base is not configured.');
  }
  const client = createAiChatHttpClient();
  if (!client) {
    throw new Error('AI chat HTTP client is not available.');
  }
  const { data } = await client.post(chatbotConfigPath(), {
    projectId: body.projectId,
    moduleId: body.moduleId,
    agentId: String(body.agentId || '').trim().toLowerCase(),
    lakehouseName: body.lakehouseName ?? '',
    lakehouseSQLEndpoint: body.lakehouseSQLEndpoint ?? '',
    customInstruction: body.customInstruction ?? '',
    introMessage: body.introMessage ?? '',
    visibility: body.visibility ?? '',
  });
  return data;
}
